function showTimeout() {
  if (typeof(Timeout)!="undefined") {
    if (Timeout>0) {
      var Interval,Msg;
      if (Timeout>60) {
        Interval=60;
        Msg=Timeout/60+' min.';
      }
      else {
        if (Timeout>10) {
          Interval=10;
        }
        else {
          Interval=1;
        };
        Msg=Timeout+' sek.';
      };
      let el=document.getElementById('timeout');
      if (el) {
        el.innerHTML=Msg;
      };
      Timeout=Timeout-Interval;
      setTimeout(showTimeout,1000*Interval);
    }
    else {
      window.location=TimeoutUrl;
    }
  }
}

$(showTimeout);